import { timeBetween, set } from "@app2/utils/helpers";
import File from "@app2/models/File";
import moment from 'moment';
import momentUTC from '@app2/utils/moment';
import eventBus from "@app2/core/eventBus";

export default {
  data() {
    return {
      publishing: false,
      unpublishing: false,
      scheduling: false,
      showPopover: false,
      scheduleAtInitial: null,
      scheduleAt: null,
      dateKey: +new Date(),
      timezone: {
        name: Intl.DateTimeFormat().resolvedOptions().timeZone,
        offset: (() => {
          function z(n){return (n<10? '0' : '') + n}
          var offset = new Date().getTimezoneOffset();
          var sign = offset < 0? '+' : '-';
          offset = Math.abs(offset);
          return sign + z(offset/60 | 0) + ':' + z(offset%60);
        })(),
      }
    }
  },
  computed: {
    model() {
      if ( this.file ) return this.file;
      if ( this.media ) return this.media;
    },
    hubConnection() {
      if ( !this.hub || !this.model?.hub_files || !Array.isArray(this.model?.hub_files) ) return;
      return this.model?.hub_files?.find(hf => hf.hub_id === this.hub.id);
    },
    publishedDate() {
      return this.hubConnection?.published_at;
    },
    isScheduled() {
      if ( !this.hubConnection || !this.publishedDate ) return false
      return !timeBetween(this.publishedDate, new Date()).isDone;
    },
    isPublished() {
      if ( !this.hubConnection ) return true; // if there is no pivot, it is published
      if ( !this.publishedDate ) return false;
      return timeBetween(this.publishedDate, new Date()).isDone;
    },
    scheduleDate: {
      get() { return this.scheduleAt },
      set(value) {
        this.scheduleAt = moment(`${value} ${this.scheduleTimeWithoutDate ? this.scheduleTimeWithoutDate : '00:00:00'}`).utc().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    scheduleTimeWithoutDate() {
      return this.scheduleAt ? moment(this.scheduleAt).format('HH:mm:ss') : null;
    },
    scheduleTime: {
      get() { return this.scheduleAt },
      set(value) {
        let date = moment.utc(this.scheduleAt).local();
        date = moment(date).format('YYYY-MM-DD')
        this.scheduleAt = moment(`${date} ${value}`).utc().format('YYYY-MM-DD HH:mm:ss');
      }
    },
    scheduleLabel() {
      return momentUTC(this.publishedDate).format("ddd, MMM D, YYYY, HH:mm[h]")
    }
  },
  methods: {
    async publish() {
      this.publishing = true;
      const {response: { data }} = await File.api( ).publish(this.model.hash, this.hub.hash);
      if (data?.data) {
        this.setPublishedState(data.data);
        eventBus.$emit('media-updated', this.model.hash);
        if ( this.showPublishToast ) this.$toasted.show('File published successfully', { type: 'success' });
      }
      this.showPopover = false;
      this.publishing = false;
    },
    async unpublish() {
      this.unpublishing = true;
      const {response: { data }} = await File.api().unpublish(this.model.hash, this.hub.hash);
      if (data?.data) {
        this.setPublishedState(data.data);
        eventBus.$emit('media-updated', this.model.hash);
        if ( this.showPublishToast ) this.$toasted.show('File unpublished successfully', { type: 'success' });
      }
      this.showPopover = false;
      this.unpublishing = false;
    },
    async schedule() {
      this.scheduling = true;
      const {response: { data }} = await File.api().schedulePublish(this.model.hash, this.hub.hash, this.scheduleAt);
      if (data?.data) {
        this.setPublishedState(data.data);
        eventBus.$emit('media-updated', this.model.hash);
        this.scheduleAtInitial = this.scheduleAt;
        this.$toasted.show('File scheduled successfully', { type: 'success' });
      }
      this.scheduling = false;
    },
    setPublishedState(data) {
      if (this.hubConnection ) {
        set(this.hubConnection, 'published_at', data.published_at);
      } else {
        set(this.model, 'hub_files', [
          ...this.model.hub_files,
          {
            hub_id: this.hub.id,
            published_at: data.published_at
          }
        ])
      }
    },
    clearSchedule() {
      this.scheduleAt = null;
      this.dateKey++;
    },
    resetSchedule() {
      this.scheduleAt = this.scheduleAtInitial;
      this.dateKey++;
    },
    setScheduleAt() {
      this.$nextTick(() => {
        if ( !this.isScheduled ) return;
        this.scheduleAt = this.publishedDate;
        this.scheduleAtInitial = this.publishedDate;
        this.dateKey++;
      })
    }
  },
  mounted() {
    this.setScheduleAt();
  }
}